import { makeStyles } from 'tss-react/mui';
export const useStyles = makeStyles()(() => ({
    IconContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    Icon: {
        borderRadius: '20px',
        height: '128px',
        width: '128px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '64px',
        '& > svg': {
            padding: '0px 16px'
        }
    },
    MfaTitle: {
        fontWeight: 800
    }
}));
//# sourceMappingURL=styles.js.map